__turbopack_context__.v({
  "motion": "_0zsX9W_motion",
  "stickerPop": "_0zsX9W_stickerPop",
  "stickerSway": "_0zsX9W_stickerSway",
});
